import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
// import '../node_modules/vuetify/dist/vuetify.min.css'
import router from './router'
import VueLazyLoad from 'vue-lazyload'
import Editor from '@tinymce/tinymce-vue'
import { format, parseISO } from 'date-fns'
import { TokenService } from '@/services/storage.service'
import { store } from './store'
import visibility from 'vue-visibility-change'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueAppleSignin from 'vue-apple-signin';
 
Vue.use(VueAppleSignin, {
  clientId: 'CLIENT_ID',
  scope: 'SCOPE',
  redirectURI: 'https://nc-photo.org/memberlogin2/api_applesignin.php',
  state: 'STATE',
});

Vue.use(visibility)
Vue.use(Editor)
Vue.use(VueLazyLoad)

Vue.config.productionTip = false

Vue.filter('formatLinebreaks', function (value) {
  if (value) {
    return value.replace(/\r/g, '\n')
  }
})

Vue.filter('formatHTMLLinebreaks', function (value) {
  if (value) {
    return value.replace(/\r/g, '<br/>')
  }
})

Vue.filter('formatDateLong', function (value) {
  if (value) {
    if( value == '0000-00-00 00:00:00') {
      return "INVALID DATE"
    }
    return format(parseISO(value), 'EEEE MMMM d, yyyy h:mm a', new Date())
  }
})

Vue.filter('formatDateHours', function (value) {
  if (value) {
    return format(parseISO(value), 'h:mm a', new Date())
  }
})

Vue.filter('formatDateJustHours', function (value) {
  if (value) {
    return format(parseISO('2019-01-01 ' + value), 'h:mm a', new Date())
  }
})

Vue.filter('formatDateDayOfWeek', function (value) {
  if (value) {
    return format(parseISO(value), 'EEEE, MMMM d', new Date())
    // return format(parseISO(value), 'dddd, MMMM D')
  }
})

Vue.filter('formatDateMonth', function (value) {
  if (value) {
    return format(parseISO(value), 'MMMM', new Date())
  }
})

Vue.filter('formatDateYearMonth', function (value) {
  if (value) {
    return format(parseISO(value), 'YYYY-MM', new Date())
  }
})

Vue.filter('formatDateMonthYear', function (value) {
  if ( value !== undefined && value != '0000-00-00 00:00:00') {
    return format(parseISO(value.substr(0,10)), "MMM yyyy", new Date())
  }
})

Vue.filter('formatDateRelative', function (value) {
  if (value) {
    return format(parseISO(value), 'MMMM dd', new Date())
  }
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

TokenService.refreshLogin()
TokenService.loadMeetingInfo()
